export const AdobeConstants = {
  ADOBE_: 'adobe-',
  LINKID: 'linkid-lc',
  WIRE: 'wire',
  INTERNAL_TRANSFER: 'internaltransfer',
  CHECK: 'check',
  MONEYLINK: 'ach',
  VIEW: 'view',
  _ALL: '_all',
  _CANCEL: '_cancel',
  _CHECK: '_check',
  _CONFIRM: '_confirm',
  _CONTINUE: '_continue',
  _CREATE_ANOTHER_REQUEST: '_create_another_request',
  _EDIT: '_edit',
  _INTERNAL_TRANSFER: '_internaltransfer',
  _MONEYLINK: '_ach',
  _SUBMIT: '_submit',
  _TRANSACTION_STATUS: '_transaction_status',
  _TWE_CHANGE: '_twe_change',
  _WIRE: '_wire',
  _CREATE_NEW_STANDING_AUTH: '_create_new_standing_auth',
  _USESAVEDTEMPLATE_FORM: 'lc_savedtemplatetoggle',
  _SAVEDTEMPLATE_TAB: 'lc_savedtemplatestart',
  _SAVETEMPLATE: 'lc_savetemplate'
};

export const FilterSLOA = {
  all: 'All',
  moneylink: 'MoneyLink On-Requests',
  check: 'Check SLOAs',
  journal: 'Journal SLOAs',
  wire: 'Wire SLOAs'
};

export const Template = {
  templateUsed: 'templateused:y',
  templateNotUsed: 'templateused:n',
  templateUsedNA: 'templateused:na'
}
